import React from 'react'
import "./ScreenReaderOnly.scss"

export interface ScreenReaderOnlyProps extends React.HTMLProps<HTMLDivElement> {}

const ScreenReaderOnly = ({ children }: ScreenReaderOnlyProps) => {
  return <div className={'screen-reader-only'}>{children}</div>;
}

export default ScreenReaderOnly